import { render, staticRenderFns } from "./IntegrationSettingsCard.vue?vue&type=template&id=f138ae34&scoped=true&"
import script from "./IntegrationSettingsCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettingsCard.vue?vue&type=style&index=0&id=f138ae34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138ae34",
  null
  
)

export default component.exports